





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/models/user/user.model';
import { UserModule } from '@/store/modules/user/user.store';
import { Role } from '@/core/security/Role';
import { AdminApi } from '@/services/api/api.admin';
import { UserUpdatePermissionsRequest, Permission, PermissionCategory, UserPermission } from '@/types/apiServerContract';

@Component
export default class PermissionsSelector extends Vue {
	@Prop({ required: true, type: Object }) user!: User;
	@Prop({ required: true, type: Object }) permission!: Permission;
	@Prop({ required: true, type: Array }) userPermissions!: UserPermission[];
	@Prop({ required: true, type: Object }) category!: PermissionCategory;
	@Prop({ required: true, type: Number }) activeRealmId!: number;

	hasPermission: boolean = false;
	hasGrantOption: boolean = false;
	canGrantOption: boolean = false;

	CheckIfHasPermission() {
	    const permission = this.userPermissions.find(x => x.permissionId === this.permission.id && x.realmId === this.activeRealmId);

	    this.hasPermission = !!permission;
	}

	CheckForGrantOption() {
	    const permission = this.userPermissions.find(x => x.permissionId === this.permission.id && x.realmId === this.activeRealmId);

	    this.hasGrantOption = permission?.withGrant ?? false;
	}

	CheckIfCanGiveGrantOption() {
	    const permissions = UserModule.user?.permissions;

	    const permission = permissions?.find(x => x.permissionId === this.permission.id && x.realmId === this.activeRealmId);

	    this.canGrantOption = (UserModule.user?.HasRole([Role.SuperAdmin]) || permission?.withGrant) ?? false;
	}

	async PermissionChanged() {
	    const request: UserUpdatePermissionsRequest = {
	        permission: {
	            userId: this.user.id,
	            realmId: this.activeRealmId,
	            permissionId: this.permission.id,
	            permission: this.permission,
	            withGrant: this.hasGrantOption
	        },
	        active: this.hasPermission
	    };
	    await AdminApi.UpdateUserPermissions(request);

	    this.$bvToast.toast(
	        `${this.user.userName}'s has ${this.hasPermission ? 'gained' : 'lost'} the ${this.permission.name} permission ${
	            this.hasGrantOption ? 'with' : 'without'
	        } grant option.`,
	        {
	            variant: 'success',
	            title: 'Success'
	        }
	    );

	    if (this.hasGrantOption && !this.hasPermission) {
	        this.hasGrantOption = false;
	    }
	}

	created() {
	    this.CheckIfHasPermission();
	    this.CheckForGrantOption();
	    this.CheckIfCanGiveGrantOption();
	}
}
